import React, { useContext, useMemo } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, REPORTS, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData, ListContext } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// LOCAL COMPONENTS
import UserName from './parts/UserName';

// STYLES
import styles from './list.module.scss';

// MAIN COMPONENT
const ReportsList = () => {
  // CONTEXT
  const { result } = useContext(ListContext) || {};

  // MEMOS
  const sortedResult = useMemo(
    () =>
      result?.map(({ report_category_name, reports }) => ({
        title: report_category_name,
        data: reports
      })),
    [result]
  );

  // RENDER
  return (
    <Main>
      <Title
        title="Reports"
        tools={
          <>
            <Title.RefreshKpiReports />
            <Title.AddGlobalLocal label="Report" />
          </>
        }
        toolsClassName={styles.tools}
        rowClassName="justify-content-start"
      />
      <Filters>
        <Filters.Button.Active />
        <Filters.Button.Global />
        <Filters.Reset />
      </Filters>
      <Table.Sorted sortedResult={sortedResult} mobilePreviewKeys={['report_title', 'is_active']} />
    </Main>
  );
};

// EXPORT
export default getListData(ReportsList, {
  key: 'reports',
  path: makePath(INTERFACE.settings, SETTINGS.reports),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.reports.list
  },
  defaults: {
    startRow: null
  },
  columns: [
    {
      key: 'report_title',
      label: 'Report Title',
      to: (_children, { report_id }) =>
        makePath(INTERFACE.settings, SETTINGS.reports, REPORTS.reports, REPORTS.run, report_id)
    },
    {
      ...COLUMNS.global,
      tooltip: 'Global reports are vailable to all dealers.'
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active reports will be available while creating report/dashboard widgets.'
    },
    COLUMNS.updatedOn,
    {
      key: 'updated_user',
      label: 'Updated By',
      width: 110,
      component: UserName
    }
  ],
  actions: [
    ACTIONS.edit('report_id'),
    {
      icon: 'play',
      label: 'Run Report',
      to: ({ report_id }) => makePath(INTERFACE.settings, SETTINGS.reports, REPORTS.reports, REPORTS.run, report_id),
      width: 110
    }
  ]
});
